export default "__VITE_ASSET__Cxi9bmDY__"